// @flow
import * as React from 'react'
import styled from '@emotion/styled'

import { colors, media } from '@toggl/style'
import { text } from '@toggl/ui'

export const Wrapper = ({
  children,
  className,
}: {|
  className?: string,
  +children: [React.Element<typeof Left>, React.Element<typeof Right>],
|}) => <CascadeWrapper className={className}>{children}</CascadeWrapper>

type ChildProps = {|
  +background?: string,
  +children: React.Node,
  +header: string | React.Node,
  +className?: string,
|}

export const Left = ({
  background,
  children,
  header,
  className,
}: ChildProps) => (
  <LeftSection background={background} className={className}>
    <LeftHeader>{header}</LeftHeader>
    {children}
  </LeftSection>
)

export const Right = ({
  background,
  children,
  header,
  className,
}: ChildProps) => (
  <RightSection background={background} className={className}>
    <RightHeader>{header}</RightHeader>
    {children}
  </RightSection>
)

const CascadeWrapper: React.ComponentType<any> = styled.div`
  padding: 30px 0 0;
  ${media.mq[1]} {
    padding: 60px 0 20px;
    position: relative;
    margin: 0 auto;
  }
  ${media.mq[2]} {
    padding: 80px 0 30px;
  }
`

const LeftSection: React.ComponentType<any> = styled.div`
  background: ${({ background, theme }) => background || theme.accent};
  padding: 60px 30px;
  color: ${colors.darkPurple};
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  ${media.mq[1]} {
    background: ${({ background, theme }) => background || theme.primary};
    padding: 60px 100px 50px;
  }
  ${media.mq[2]} {
    margin: 0 0 20px;
    width: 60%;
    max-width: 710px;
    position: relative;
    z-index: 2;
  }
`

const LeftHeader = styled.div`
  ${text.heading3};
  width: 200px;
  margin: 0 auto 30px;
  color: ${colors.darkPurple};

  ${media.mq[1]} {
    ${text.heading2};
    color: ${colors.darkPurple};
    width: 330px;
    margin: 0;
    margin-bottom: 40px;
  }
`

const RightSection: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px 30px;
  max-width: 800px;
  margin: 0 auto;
  ${media.mq[1]} {
    padding: 60px 100px;
  }
  ${media.mq[2]} {
    background-color: ${colors.darkPurple};
    color: ${({ theme }) => theme.accent};
    padding: 60px 50px 60px 150px;
    max-width: 580px;
  }
`

const RightHeader = styled.div`
  ${text.heading3};
  margin-bottom: 38px;
`
